/* Ascendia product page - 6 Oct 2026 (tools/pdp-redesign-6oct2026/REPORT.md). Phone only (< 750px). ~2 KB.
   1. Gallery overlay: thin progress bar, "3 / 15" counter, two arrows. Counts only the slides the colour filter shows
      (assets/media-gallery.js toggles .asc-hide / .asc-show), so Lavender's 7 photos read 1 / 7, not 1 / 15.
   2. Bottom bar: the theme's sticky bar (snippets/new-atc.liquid) shows only once the main ADD TO CART has scrolled above
      the screen, so it never covers the photo, the colours or the sizes while they are being used.
   Does nothing on desktop, does nothing if the gallery is missing, never throws. */
(function () {
  'use strict';
  var mq = window.matchMedia('(max-width: 749px)');

  function visibleSlides(ul) {
    return Array.prototype.filter.call(ul.querySelectorAll('.product__media-item'), function (s) {
      return s.offsetWidth > 0 && window.getComputedStyle(s).display !== 'none';
    });
  }

  function gallery() {
    var wrap = document.querySelector('.product__media-wrapper');
    var ul = wrap && wrap.querySelector('.product__media-list');
    if (!wrap || !ul || wrap.querySelector('.asc-g-bar')) return;
    var bar = document.createElement('div'); bar.className = 'asc-g-bar'; bar.setAttribute('aria-hidden', 'true'); bar.innerHTML = '<i></i>';
    var count = document.createElement('div'); count.className = 'asc-g-count'; count.setAttribute('aria-live', 'polite');
    var mk = function (cls, label, dir) {
      var b = document.createElement('button'); b.type = 'button'; b.className = 'asc-g-arrow ' + cls; b.setAttribute('aria-label', label);
      b.innerHTML = dir < 0
        ? '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 5l-7 7 7 7"/></svg>'
        : '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 5l7 7-7 7"/></svg>';
      b.addEventListener('click', function () { step(dir); });
      return b;
    };
    var ar = (document.documentElement.lang || '').indexOf('ar') === 0;
    var prev = mk('asc-g-prev', ar ? 'الصورة السابقة' : 'Previous photo', -1);
    var next = mk('asc-g-next', ar ? 'الصورة التالية' : 'Next photo', 1);
    var host = ul.parentNode; // slider-component
    host.appendChild(bar); host.appendChild(count); host.appendChild(prev); host.appendChild(next);
    if (window.getComputedStyle(host).position === 'static') host.style.position = 'relative';

    var slides = [], idx = 0, touched = false;
    ul.addEventListener('touchstart', function () { touched = true; }, { passive: true });
    ul.addEventListener('pointerdown', function () { touched = true; }, { passive: true });
    /* which visible slide sits at the list's start edge - measured with rects, so it is right in LTR, Chrome-RTL and Safari-RTL alike */
    function current() {
      var base = ul.getBoundingClientRect(), best = 0, bd = Infinity;
      for (var i = 0; i < slides.length; i++) {
        var r = slides[i].getBoundingClientRect(), d = Math.abs(r.left - base.left) + Math.abs(r.right - base.right);
        if (d < bd) { bd = d; best = i; }
      }
      return best;
    }
    function render(fromMutation) {
      slides = visibleSlides(ul);
      var n = slides.length;
      wrap.classList.toggle('asc-g-single', n < 2);
      if (n < 2) return;
      /* after the colour filter hides/shows slides and before the shopper has touched the gallery, start on the colour's FIRST photo
         (Safari RTL otherwise keeps an old offset and lands mid-gallery) */
      /* 7 Oct 2026 (round 2): scroll the gallery STRIP only. scrollIntoView(block:'nearest') also scrolled the PAGE back up to
         the photo whenever a size was tapped (the size change re-marks the active slide), on live EN + AR. */
      if (fromMutation && !touched && slides[0]) {
        var wx = window.pageXOffset, wy = window.pageYOffset;
        slides[0].scrollIntoView({ behavior: 'instant', inline: 'start', block: 'nearest' });
        if (window.pageYOffset !== wy || window.pageXOffset !== wx) window.scrollTo(wx, wy);
      }
      idx = current();
      count.textContent = (idx + 1) + ' / ' + n;
      bar.firstChild.style.transform = 'scaleX(' + ((idx + 1) / n).toFixed(4) + ')';
      prev.disabled = idx === 0; next.disabled = idx === n - 1;
    }
    function step(dir) {
      var n = slides.length; if (!n) return;
      var to = Math.max(0, Math.min(n - 1, idx + dir));
      var target = slides[to]; if (!target) return;
      /* one call for both directions: in RTL Chrome counts scrollLeft from 0 downwards, so offsets are not portable */
      target.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
    }
    var raf = 0;
    ul.addEventListener('scroll', function () { if (!raf) raf = requestAnimationFrame(function () { raf = 0; render(); }); }, { passive: true });
    window.addEventListener('resize', function () { render(); });
    if ('MutationObserver' in window) {
      var t = 0;
      new MutationObserver(function () { clearTimeout(t); t = setTimeout(function () { render(true); }, 80); }).observe(ul, { attributes: true, subtree: true, attributeFilter: ['class', 'style', 'aria-hidden'] });
    }
    render();
    setTimeout(function () { render(true); }, 600);
    setTimeout(function () { render(true); }, 2500);
  }

  function stickyBar() {
    var bar = document.querySelector('.sticky-atc');
    var main = document.querySelector('[id^="ProductSubmitButton-"]');
    if (!bar || !main) return;
    document.body.classList.add('asc-pdp-bar');
    function sync() {
      if (!mq.matches) return;
      var r = main.getBoundingClientRect();
      /* phone rule (Majed, 6 Oct): the bar may never sit over the photo, the colours or the sizes while they are being read, so it
         appears only once the main ADD TO CART has scrolled ABOVE the screen (r.bottom < 0), like Vuori's. */
      var inView = !(r.bottom < 0 && r.height > 0);
      var footer = document.querySelector('.footer__content-bottom');
      var fr = footer && footer.getBoundingClientRect();
      var footerIn = fr && fr.top < window.innerHeight && fr.bottom > 0;
      bar.classList.toggle('show', !inView && !footerIn);
    }
    window.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    if ('IntersectionObserver' in window) new IntersectionObserver(sync, { threshold: [0, 0.01, 1] }).observe(main);
    sync();
    setTimeout(sync, 400);
    setTimeout(sync, 1500);
  }

  function boot() {
    if (!mq.matches) return;
    try { gallery(); } catch (e) { /* never break the page */ }
    try { stickyBar(); } catch (e) { /* idem */ }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
